import create from "zustand";

export type useCopyExamsAccessStoreType = {
  hasAccess: boolean | null;
  hasFetched: boolean;
  setHasAccess: (hasAccess: boolean) => void;
};
export const useCopyExamsAccessStore = create<useCopyExamsAccessStoreType>(
  (set) => {
    return {
      hasAccess: null,
      hasFetched: false,

      setHasAccess: (hasAccess: boolean) => {
        set(() => ({
          hasAccess,
          hasFetched: true,
        }));
      },
    };
  }
);
